import { inject, Injectable } from '@angular/core';
import { CommonService } from '../common.service';
import { OverviewReportRequestData } from '../customer-report.service';
import { Observable } from 'rxjs';
import {
    OverviewReportResponse,
    SummaryReportGenerationRequest,
    SummaryReportGenerationResponse,
    SummaryReportStatusRequest,
    SummaryReportStatusResponse
} from '../../components/report/report.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerReportApiService {
  private readonly commonService = inject(CommonService);

  constructor() {}

  getOverviewReport(requestData: OverviewReportRequestData): Observable<OverviewReportResponse> {
    return this.commonService.postRequest('summary-report/get-summary-report-data', requestData);
  }

  startSummaryReportGeneration(requestData: SummaryReportGenerationRequest): Observable<SummaryReportGenerationResponse> {
    return this.commonService.postRequest('summary-report/start-summary-report-generation', requestData);
  }

  getSummaryReportStatus(requestData: SummaryReportStatusRequest): Observable<SummaryReportStatusResponse> {
    return this.commonService.postRequest('summary-report/get-summary-report-status', requestData);
  }
}
